import getAddresses from './getAddresses';
import deleteAddress from './deleteAddress';

const watchAddresses = [getAddresses,deleteAddress];

export default watchAddresses;
